module.exports = __webpack_public_path__ + "static/cashew_nuts_dieu_2-8367159c23a44d42f16ec88d5921a792.jpg";